import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard, StructuredMetadataTable } from '@backstage/core-components';

export const EntityAnnotationsCard = ({
  variant,
}: {
  variant?: 'gridItem';
}) => {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations || {};

  if (Object.keys(annotations).length === 0) {
    return null;
  }

  return (
    <InfoCard title="Annotations" variant={variant}>
      <StructuredMetadataTable metadata={annotations} />
    </InfoCard>
  );
};
